import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  reportTypes: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the reportTypes
export const fetchReportTypes = createAsyncThunk(
  "fetchReportTypes/reportTypes",
  async ({ enqueueSnackbar, limit=10, page=0, filter, search }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`settings/report-types`, {
        params: {
          page: page + 1,
          limit,
          ...(filter &&
            filter.status && {
              status: filter.status,
            }),
          ...(search !== "" && {
            search,
          }),
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create reportType
export const createReportType = createAsyncThunk(
  "createReportType/reportTypes",
  async ({ data, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`settings/report-types`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update reportType
export const updateReportType = createAsyncThunk(
  "updateReportType/reportTypes",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.put(`settings/report-types/${id}`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete reportType
export const deleteReportType = createAsyncThunk(
  "deleteReportType/reportTypes",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`settings/report-types/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const reportTypeslice = createSlice({
  name: "reportType",
  initialState,
  extraReducers: (builder) => {
    // TODO: create reportType
    builder.addCase(fetchReportTypes.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchReportTypes.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.isLoading = false;
      state.reportTypes = action.payload;
    });

    builder.addCase(fetchReportTypes.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: create reportType
    builder.addCase(createReportType.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createReportType.fulfilled, (state, action) => {
      state.isLoading = false;
      state.reportTypes.data = [action.payload.data, ...state.reportTypes.data];
      state.reportTypes.meta.total = state.reportTypes.meta.total + 1;
      action.payload.enqueueSnackbar("ReportType is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createReportType.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: update reportType
    builder.addCase(updateReportType.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateReportType.fulfilled, (state, action) => {
      state.isLoading = false;
      state.reportTypes.data = state.reportTypes.data.map((reportType) => {
        if (reportType.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return reportType;
        }
      });
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar("ReportType is updated successfully.", {
          variant: "success",
        });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateReportType.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar(
          JSON.stringify(
            action.payload.error ||
              action.payload.error.errors ||
              action.payload.error.message
          ),
          {
            variant: "error",
          }
        );
    });

    // TODO: delete reportType
    builder.addCase(deleteReportType.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteReportType.fulfilled, (state, action) => {
      state.isLoading = false;
      state.reportTypes.data = state.reportTypes.data.filter(
        (reportType) => reportType.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("ReportType is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteReportType.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default reportTypeslice.reducer;
